if (!customElements.get("accordion-section")) {
  class AccordionSection extends HTMLElement {
    constructor() {
      super();
  
      this.searchInput = this.querySelector("input.js-accordion-search");
      this.accordions = this.querySelectorAll(".js-accordion-item");
      this.tabs = this.querySelectorAll(".js-tab");
      this.tabContents = this.querySelectorAll(".js-tab-content");
  
      this.searchInput?.addEventListener("input", this.filterItems.bind(this));
    }
  
    filterItems() {
      const unformattedFilter = this.searchInput.value;
      const filter = this.searchInput.value.toLowerCase();
  
      this.tabContents.forEach((tabContent) => {
        const tabAccordions = tabContent.querySelectorAll(".js-accordion-item");
        const tabTitle = this.querySelector(
          `.js-tab[data-tab="${tabContent.getAttribute("data-content")}"]`
        );
        let hiddenCount = 0;
        let resultsCount = 0;
        tabAccordions.forEach((item) => {
          const accordionTitle = item.querySelector(".js-accordion-title");
          const text = accordionTitle.textContent.toLowerCase();
          const match = text.includes(filter);
          item.hidden = !match;

          const highlightedText = match
            ? accordionTitle.textContent.replace(
                new RegExp(filter, "gi"),
                (match) => `<mark>${match}</mark>`
              )
            : accordionTitle.textContent;

          accordionTitle.innerHTML = highlightedText;
  
          if (match) {
            resultsCount++;
          }

          if (!match) {
            hiddenCount++;
          }
        });
  
        if (hiddenCount === tabAccordions.length) {
          tabContent?.classList.add("hidden");
          tabTitle?.classList.add("hidden");
        } else {
          tabContent?.classList.remove("hidden");
          tabTitle?.classList.remove("hidden");
        }

        if (tabContent) {
          const resultsCountElement = tabContent.querySelector('.js-accordion-results-count');
          const resultsCountText = resultsCount === 1 ? window.accordionSearchStrings.results.one.replace('[term]', unformattedFilter) : window.accordionSearchStrings.results.other.replace('[count]', resultsCount).replace('[term]', unformattedFilter);
          
          resultsCountElement.innerHTML = filter ? resultsCountText : '';
        }
  
        this.openFirstTab();
      });
    }
  
    openFirstTab() {
      const firstTab = this.querySelector(".js-tab:not(.hidden)");
      if (firstTab) {
        firstTab.click();
  
        const firstTabContent = this.querySelector(
          `.js-tab-content[data-content="${firstTab.getAttribute("data-tab")}"]`
        );
        if (firstTabContent) {
          const firstAccordion = firstTabContent.querySelector(
            ".js-accordion-item:not([hidden])"
          );
          if (firstAccordion) {
            firstAccordion.setAttribute("open", "");
          }
        }
      }
    }
  }
  customElements.define("accordion-section", AccordionSection);
}
